import type { ReactNode } from "react";
import { Link } from "react-router";

/** Centered card for the signed-out pages. */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="auth-page">
      <div className="card auth-card">
        <p className="brand">ten20</p>
        <h1>{title}</h1>
        {children}
        <p className="hint">
          <Link to="/privacy">Privacy policy</Link> · <Link to="/terms">Chat terms</Link>
        </p>
      </div>
    </main>
  );
}
